import { otherApiClient } from ".";
export const getLanding = async (type, slug)=>{
    const { data  } = await otherApiClient.market.get("/landing/".concat(type, "/").concat(slug));
    return data;
};
export const validateMembership = async (body)=>{
    const { data  } = await otherApiClient.market.post("/landing/membership", body);
    return data;
};
export const postValidateHandout = async (body)=>{
    const { data  } = await otherApiClient.market.post("/landing/handout", body);
    return data;
};
